// SIP traces of the browser phone.
//
// JsSIP (loaded from public/, see index.html) ships the "debug" module. Its
// switch is stored in this browser's localStorage under the key "debug", so it
// survives reloads, applies to this browser only, and takes effect immediately.

const NAMESPACES = "JsSIP:*";

const debugApi = () => (typeof window !== "undefined" && window.JsSIP && window.JsSIP.debug) || null;

export const sipTraceAvailable = () => debugApi() !== null;

export const isSipTraceEnabled = () => {
  try {
    return String(window.localStorage.getItem("debug") || "")
      .split(/[\s,]+/)
      .some((name) => name.startsWith("JsSIP"));
  } catch (e) {
    return false;
  }
};

export const setSipTraceEnabled = (enabled) => {
  const api = debugApi();
  if (!api) return false;
  if (enabled) {
    api.enable(NAMESPACES);
  } else {
    api.disable();
  }
  return isSipTraceEnabled();
};
